module.exports = __webpack_public_path__ + "img/changeCardAd.6a8c1e20.png";